import React, { useEffect } from "react";
import styled, { keyframes } from "styled-components";
import AOS from "aos";
AOS.init({
  // Global settings:
  disable: false, // accepts following values: 'phone', 'tablet', 'mobile', boolean, expression or function
  startEvent: "DOMContentLoaded", // name of the event dispatched on the document, that AOS should initialize on
  initClassName: "aos-init", // class applied after initialization
  animatedClassName: "aos-animate", // class applied on animation
  useClassNames: false, // if true, will add content of `data-aos` as classes on scroll
  disableMutationObserver: false, // disables automatic mutations' detections (advanced)
  debounceDelay: 50, // the delay on debounce used while resizing window (advanced)
  throttleDelay: 99, // the delay on throttle used while scrolling the page (advanced)

  // Settings that can be overridden on per-element basis, by `data-aos-*` attributes:
  offset: 120, // offset (in px) from the original trigger point
  delay: 0, // values from 0 to 3000, with step 50ms
  duration: 400, // values from 0 to 3000, with step 50ms
  easing: "ease", // default easing for AOS animations
  once: false, // whether animation should happen only once - while scrolling down
  mirror: false, // whether elements should animate out while scrolling past them
  anchorPlacement: "top-bottom", // defines which position of the element regarding to window should trigger the animation
});
const Drone = () => {
  useEffect(() => {
    AOS.init({
      duration: 1800,
    });
    AOS.refresh();
  }, []);
  return (
    <Main data-aos="fade-up">
      <Marquee>
        <img src="./drone.gif"></img>
      </Marquee>
    </Main>
  );
};

const Main = styled.div`
  width: 100%;
  position: relative;
  overflow: hidden;
  margin-top: 4%;
`;

const move = keyframes`
  from { transform: translateX(0%); }
  to { transform: translateX(100%); }
`;

const Marquee = styled.div`
  width: 80%;

  display: inline-block;
  white-space: nowrap;
  animation: ${move} 8s linear infinite;
  animation-direction: alternate-reverse;
  img {
    width: 80vw;
    max-width: 400px;
    height: auto;
  }

  @media (max-width: 768px) {
    img {
      width: 90vw;
    }
  }
`;

const Marquee2 = styled.div`
  width: 50%;
  display: inline-block;
  white-space: nowrap;
  animation: ${move} 8s linear infinite;
  animation-direction: alternate-reverse;
  img {
    width: 80vw; /* Set image width as 80% of the viewport width */
    max-width: 400px; /* Set a maximum width to limit the size on larger screens */
    height: auto; /* Maintain aspect ratio */
  }

  @media (max-width: 768px) {
    img {
      width: 90vw; /* Decrease image width on smaller screens */
    }
  }
`;
export default Drone;
